<script>
import MedicarePath from "@/components/MedicarePath"
import NavBar from "@/components/NavBar"
import FooterSection from "@/components/FooterSection"
import { init } from "@/paths/helpers"

export default {
  name: 'App',
  components: {
    MedicarePath,
    NavBar,
    FooterSection,
  },

  created() {
    function addPushnami() {
      let pushnamiKey = '615740c73919520010f5d50d';
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = 'https://api.pushnami.com/scripts/v1/pushnami-adv/' + pushnamiKey;
      script.onload = function() {
        window.Pushnami
            .update()
            .prompt();
      };
      document.getElementsByTagName("head")[0].appendChild(script);
    }

    addPushnami()
    init(this)
  },
}
</script>

<template>
  <div>
    <nav-bar />
    <medicare-path />
    <footer-section />
  </div>
</template>

<style lang="scss">
  @import "./../../scss/style";
</style>
